import Photo from '../Photo/Photo';
import './PhotoList.scss';
import PropTypes from 'prop-types';

// Common PhotoList Component
const PhotoList = ({ photos, modelName, refetchPhotos, setError, completed }) => {
  return (
    <div className="photo_list_container">
      {photos?.map((photo, index) => (
        <Photo
          photo={photo}
          number={index + 1}
          key={photo.id}
          refetchPhotos={refetchPhotos}
          modelName={modelName}
          setError={setError}
          completed={completed}
        />
      ))}
    </div>
  );
};

PhotoList.propTypes = {
  photos: PropTypes.array,
  modelName: PropTypes.string,
  refetchPhotos: PropTypes.func,
  setError: PropTypes.func,
  completed: PropTypes.bool,
};

export default PhotoList;
